export const POPUP_TYPES = {
  PROMOTION: 'Promotion',
  DISCLAIMER: 'Disclaimer',
  DESKTOP_INSTALLER: 'Desktop-Installer',
};

export const TRIGGER_EVENTS = {
  TIMED: 'Timed',
  EXIT_INTENT: 'Exit-Intent',
  PAGE_DEPTH: 'Page Depth',
  BUTTON_LINK_CLICK: 'Button / Link Click',
};

export const COUNTRY_CODES = {
  US: 'AU',
};

export const SHOW_BUTTONS = {
  YES: 'yes',
  NO: 'no',
};

export const MODAL_QUERY_PARAM = 'modal';
export const MODAL_QUERY_PARAM_MAP = {
  'desktop-download': POPUP_TYPES.DESKTOP_INSTALLER,
};
